module.exports = __webpack_public_path__ + "static/media/uae_flag.eb542ae5.svg";